<div class="home-container"
	 [ngClass]="drawerOpen ? 'drawer-open' : 'drawer-close'"
	 [ngClass]="isLoggedIn ? '' : 'drawer-close-wide'"
	 role="main">
	<app-carousel [items]="carouselItem"></app-carousel>

	<!--TO DO-->
	<!-- <app-search-categories [item]="categoryItems"
						   *ngIf="categoryItems"></app-search-categories> -->
	<app-search-categories [item]="professionCategoryItems"
						   *ngIf="professionCategoryItems">
	</app-search-categories>
	<ng-container *ngIf="cards && cards[0] && cards[0]!.items.length > 0">
		<app-card [items]="cards"></app-card>
	</ng-container>

	<!--Shimmer-->
	<div class="shimmer-container">
		<ng-container *ngIf="loading">
			<div class="shimmer-container">
				<app-shimmer [type]="shimmerTypeSMCard"
							 *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"></app-shimmer>
			</div>
		</ng-container>
	</div>
</div>

<!--Footer-->
<div class="footer-container">
	<div>
		<div class="info-parent-container">
			<div class="logo-container">
				<img src="assets/images/arogyamm.png"
					 alt=""
					 srcset="" />
			</div>
			<div class="info-container">
				<div>
					<a href="/privacypolicy"
					   target="_blank"
					   rel="noopener noreferrer">
						<span>{{ "privacy-policy" | transloco }}</span>
						<app-icon [item]="externalLinkIcon"></app-icon>
					</a>
				</div>
				<div>
					<a href="/termsofuse"
					   target="_blank"
					   rel="noopener noreferrer">
						<span>{{ "terms-of-use" | transloco }}</span>
						<app-icon [item]="externalLinkIcon"></app-icon>
					</a>
				</div>
				<div>
					<a href="/contactus"
					   target="_blank"
					   rel="noopener noreferrer">
						<span>{{ "contact-us" | transloco }}</span>
						<app-icon [item]="externalLinkIcon"></app-icon>
					</a>
				</div>
				<div>
					<a href="https://www.doctors.arogyaline.com"
					   target="_blank"
					   rel="noopener noreferrer">
						<span>{{ "for-medical-professionals" | transloco }}</span>
						<app-icon [item]="externalLinkIcon"></app-icon>
					</a>
				</div>
			</div>
		</div>
	</div>
	<div class="powered-by-container">
		<div class="logo-container">
			<span>Powered By</span>
			<a href="https://www.rkbsoftware.com"
			   target="_blank"
			   aria-label="">
				<img src="assets/images/logo.png"
					 alt=""
					 srcset="" />
				<img src="assets/images/logo-text.png"
					 alt=""
					 srcset="" />
			</a>
		</div>
	</div>
	<div>
		<span>{{ "copyright-txt" | transloco }}</span>
	</div>
</div>
